module.exports = __webpack_public_path__ + "img/signals_preview.a4a0ca3a.png";